/** 线上活跃用户 */
import { GetActiveUserMonth } from '@/services/api'
import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import { Area } from '@ant-design/charts'
import React, { useCallback, useMemo, useState, useEffect ,forwardRef} from 'react'
import Panel from '@/components/Panel/index'
import styles from './style.module.scss'
import ImgSource from '@/assets/img/resource/bowei.png'
import Abutton from '@/components/Abutton'
import ReactEcharts from 'echarts-for-react'
/** 设备管理跳转地址 */
const iframeURL = "http://lz.dgjx0769.com/lz/#/UrbanIntegration/BasicDataManage/DeviceManage";


interface UserData {
  date: string;
  activeUserTotal: number;
}

interface FormattedData {
  date: string;
  value: number;
  type: string;
}

const ParkingDeviceCount:React.FC<{
  areaCode?: string;
}> = forwardRef(({areaCode},ref) => {
  const { loading, data, error } = useRequest(useCallback(() => {
    return GetActiveUserMonth({areaCode} )
  },[areaCode]),
  { 
    formatResult: (res: { data: { members: UserData[]; nonMembers: UserData[] } }) => {
      const members = res.data.members.map((item) => ({
        date: (item.date).split('-')[1] + '-' + (item.date).split('-')[2],
        value: item.activeUserTotal,
        type: '会员'
      }));
      const nonMembers = res.data.nonMembers.map((item) => ({
        date: (item.date).split('-')[1] + '-' + (item.date).split('-')[2],
        value: item.activeUserTotal,
        type: '非会员'
      }));
      return [...members, ...nonMembers];
    },
    refreshDeps: [areaCode]
  })

  const chartData = useMemo(() => data || [], [data]);

  // 如果有错误，显示错误信息
  if (error && !loading) {
    return (
      <Panel title="线上活跃用户">
        <div className="fetch_container" style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    );
  }
  
  return (
    <Panel title="线上活跃用户">
      {chartData.length > 0 ? (
        <Area
          height={200}
          padding={[20, 20, 23, 48]}
          smooth={true}
          data={chartData}
          xField='date'
          yField='value'
          seriesField='type'
          startOnZero={false}
          // legend={{
          //   position: 'top',
          //   itemName: {
          //     style: {
          //       fill: '#fff'
          //     }
          //   }
          // }}
          legend={false}
          xAxis={{
            label: {
              style: {
                fill: '#fff',
              },
            },
            line: {
              style: {
                stroke: '#12708D',
              },
            },
            tickLine: null,
            range: [0, 1],
          }}
          yAxis={{
            label: {
              style: {
                fill: '#fff',
              },
              formatter: (v) => `${v}`,
            },
            line: {
              style: {
                stroke: '#12708D',
              },
            },
            grid: {
              line: {
                style: {
                  stroke: '#12708D',
                  strokeOpacity: 0.4,
                },
              },
            },
            minTickInterval: 50,
            min: 0,
          }}
          areaStyle={{
            fill: 'l(90) 1：#ffffff 0.5:#A9FEF3 0:#02E6CB',
          }}
          tooltip={{
            formatter: (data) => {
              return {
                name: `${data.type}`,
                value: `${data.value}个`,
              }
            },
            showTitle: false,
          }}
          animation={{
            appear: {
              animation: 'path-in',
              duration: 3000,
            },
            enter: {
              easing: 'easeLinear',
              duration: 3000,
              delay: 2000,
            },
          }}
        />
      ) : (
        <div className='fetch_container' style={{ height: 200 }}>
          暂无数据
        </div>
      )}
    </Panel>
  )
})

export default ParkingDeviceCount